import { render } from "./Register.view.vue?vue&type=template&id=0f1828b4"
import script from "./Register.view.vue?vue&type=script&lang=js"
export * from "./Register.view.vue?vue&type=script&lang=js"

import "./Register.view.vue?vue&type=style&index=0&id=0f1828b4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__